import { Box } from '@factorialco/deprecated-design-system'

import './index.styles.css'
import { Body } from './Body'
import { Image } from './Image'
import { Video } from './Video'

export type MotionType = 'video' | 'image'
interface Props {
  variant?: 'borderless' | 'border'
  motion: {
    url: string
    alt: string
    type: 'video' | 'image'
  }
  body: {
    title: string
    subTitle?: string
    description?: string
    children?: React.ReactNode
  }
}

export const MotionInformation = ({ variant = 'borderless', motion, body }: Props) => {
  return (
    <Box gap="s32" justifyContent="center" className={`MotionInformation_variants_${variant}`}>
      <Box className={'MotionInformation_motionBox'}>
        {motion.type === 'video' ? (
          <Video src={motion.url} alt={motion.alt} />
        ) : (
          <Image src={motion.url} alt={motion.alt} />
        )}
      </Box>
      {body.children && (
        <Body title={body.title} subTitle={body.subTitle} description={body.description}>
          {body.children}
        </Body>
      )}
    </Box>
  )
}
